import { memo } from 'react';
import { Zoom } from 'react-awesome-reveal';
import type { IntroCrawlProps } from '../store/types';

const IntroCrawl = ({ fadeOutIntroText, fadeOutCrawlText, hideIntroCrawlText = false }: IntroCrawlProps) => {
  return (
    <div className={'star_wars_wrapper intro_text_wrapper d-flex align-items-center justify-content-center  '}>
      <div className="container-fluid d-flex justify-content-center align-items-center">
        <div className="row d-flex justify-content-center align-items-center">
          <div className="col-lg-12 position-relative d-flex justify-content-center align-items-center text-center">
            <Zoom delay={1000}>
              <span className={' intro__text  fade_transition text-center' + (fadeOutIntroText ? '  hide' : ' ')}>
                <span className=' text-center'>A long time ago in a galaxy far far away....</span>
              </span>
            </Zoom>

            {fadeOutIntroText && !hideIntroCrawlText && (
              <div className={' intro-crawl-text   fade_transition ' + (fadeOutCrawlText ? ' hide  ' : '  ')}>
                <section className="star-wars">
                  <div className="crawl">
                    <div className="title">
                      <h2>Episode XXI</h2>
                      <h1>The Solution Awakens</h1>
                    </div>

                    <h3>The galaxy picked up your mysterious broadcast in search of a software developer.</h3>
                    <h3>Hi, I’m Serouj—your solution.</h3>
                  </div>
                </section>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(IntroCrawl);
